import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurkeyFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0003 0.000488292C35.9337 0.000597581 41.7337 1.76017 46.6671 5.05669C51.6005 8.35321 55.4455 13.0386 57.716 18.5204C59.9866 24.0023 60.5806 30.0342 59.4229 35.8537C58.2653 41.6731 55.408 47.0185 51.2124 51.214C47.0169 55.4095 41.6714 58.2667 35.852 59.4241C30.0326 60.5816 24.0007 59.9875 18.519 57.7168C13.0373 55.4461 8.35205 51.6009 5.05569 46.6674C1.75934 41.7338 -5.539e-05 35.9337 1.30788e-09 30.0002C1.98794e-06 26.0605 0.775989 22.1594 2.28366 18.5196C3.79132 14.8798 6.00114 11.5727 8.78693 8.78692C11.5727 6.00117 14.8799 3.79143 18.5197 2.28385C22.1595 0.776268 26.0606 0.000380934 30.0003 0.000488292V0.000488292Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.3483 37.0007L39.3589 31.6452L33.9997 30.0004L39.3589 28.3555L39.3483 23.0005L42.6478 27.3393L48.0001 25.6737L44.6809 30.0004L48.0001 34.3264L42.6478 32.6607L39.3483 37.0007Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.2502 42.001C28.0911 41.9652 25.0736 40.6851 22.8523 38.4385C20.631 36.1919 19.3852 33.1601 19.3852 30.0008C19.3852 26.8414 20.631 23.8096 22.8523 21.563C25.0736 19.3164 28.0911 18.0363 31.2502 18.0005C33.6665 17.9991 36.0242 18.7447 38.0002 20.1354C36.6183 18.5251 34.9047 17.2326 32.9767 16.3463C31.0487 15.46 28.952 15.0009 26.83 15.0005C22.8814 15.0455 19.1098 16.6457 16.3334 19.4539C13.5571 22.262 12 26.0517 12 30.0006C12 33.9496 13.5571 37.7392 16.3334 40.5474C19.1098 43.3556 22.8814 44.9558 26.83 45.0008C28.9518 45.0003 31.0484 44.5414 32.9763 43.6554C34.9042 42.7695 36.618 41.4775 38.0002 39.8678C36.0241 41.2581 33.6664 42.0033 31.2502 42.001Z",
			fill: "white"
		})
	]
});
export default SvgTurkeyFlag;
